import { useContext } from 'react';
import { Buttons, FlexContainer, ModalContext, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { openLinkInNewTab } from 'Utils/links';
import { INVALID_SAT_CLABE_URL } from 'Constants/helpsUrl';
import { TaxScreenType } from 'Types/common';
import * as Styled from '../styles';
import ResultInfo from '../ResultInfo';
import ValidClabeForm from '../ValidClabeForm';

const InvalidSatClabe = ({ tax: { taxYear, filingInfo } }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { data } = useFetchGetUserClabe();
  const { showModal } = useContext(ModalContext);

  const handleClick = (): void => {
    showModal({
      comp: <ValidClabeForm clabeUser={data?.CLABE} />,
    });
  };
  return (
    <FlexContainer justify="center" direction="column" align="center" gap="dimension_08" fullHeight>
      <Text size="L_L_S" color="dark" type="headline">
        {taxYear}
      </Text>
      <Text type="paragraphs" size="L_L_M" color="dark" align="center">
        {t('Dashboard.invalid_sat_clabe.message')}
      </Text>
      <Styled.StyledLottie
        options={{
          path: lottiesPaths.MORE_INFO,
          rendererSetting: { progressiveLoad: true },
        }}
      />
      {filingInfo && <ResultInfo filingInfo={filingInfo} />}
      <FlexContainer direction="column" gap="dimension_16" align="center">
        <Text type="paragraphs" color="dark" size="M_L_S" align="center">
          {t(`Invalid_sat_clabe.title`)}
        </Text>
        <Text type="paragraphs" color="dark" size="S_S_S" align="center">
          {t(`Invalid_sat_clabe.description`)}
        </Text>
        <Buttons.Classic
          label={t('Dashboard.invalid_sat_clabe.button')}
          mode="primary"
          size="m"
          onClick={handleClick}
        />
        <Buttons.Tiny
          label={t('Dashboard.invalid_sat_clabe.tiny_button')}
          mode="default"
          onClick={() => openLinkInNewTab(INVALID_SAT_CLABE_URL)}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default InvalidSatClabe;
